<script setup>
import {useRoute} from "vue2-helpers/vue-router";
import {ref, onMounted, watch} from "vue";
import {useStore} from "vue2-helpers/vuex";
import publicTrackersService from "@/services/public-trackers.service";
import Application from "@/components/trackers/application/Application.vue";
import SimpleSignup from "@/views/common/SimpleSignup.vue";
import trackersService from "@/services/trackers.service";

const route = useRoute();
const store = useStore();
const id = route.params.id;
const signup = ref(null);
const showDetails = ref(null);
const trackerId = ref(0);

watch(() => store.getters.isLoggedIn, async (value) => {
    if (value) {
        document.body.classList.remove('public-view');
    } else {
        document.body.classList.add('public-view');
    }
}, {immediate: true});

onMounted(async () => {
    if (route.query['apply']) {
        signup.value.modalAction = 'login';
    }

    const {data} = await publicTrackersService.getId(id);
    trackerId.value = data;

    await checkUser();
});

async function checkUser() {
    if (store.getters.isLoggedIn) {
        watch(() => store.getters.isEnterprise, async (isEnterprise) => {
            if (isEnterprise) {
                const {data} = await trackersService.checkEnterpriseAccess(trackerId.value);

                if (data) {
                    window.location.href = '/trackers/' + trackerId.value
                }
            } else {
                showDetails.value = true;
            }
        }, {immediate: true});
    } else {
        const {data} = await publicTrackersService.checkCanShowToGuest(id);
        showDetails.value = data;

        if (!showDetails.value) {
            signup.value.show();
        }
    }
}
</script>

<template>
    <main :class="{'enter-page': !showDetails}">
        <template v-if="showDetails !== null">
            <Application
                v-if="showDetails"
                :id="id"
                :tracker-id="trackerId"
                @login="signup.show()"
            />

            <header v-else class="header">
                <span class="logo"></span>
            </header>
        </template>

        <SimpleSignup
            ref="signup"
            company-type="startup"
            :disable-hide="!showDetails"
            :return-url="`${route.fullPath}?apply=1`"
            :tracker-id="trackerId"
            @loggedIn="showDetails = true"
        />
    </main>
</template>

<style scoped>

</style>
